import React from 'react';
import male from './resources/male1.png';
import female from './resources/female1.png';
import { HeartBox, Wrap } from './styles';

type Props = {
    gender?: number;
}

export const Gender = ({ gender }: Props) => {
    return (
        <Wrap>
            <HeartBox src={gender === 1 ? female : male} />
        </Wrap>
    );
}